import React, { SVGProps } from "react";
import { ReactComponent as PetDogSVG } from "../Images/petDogNew.svg";
import { ReactComponent as PetCatSVG } from "../Images/petCat.svg";
import { ReactComponent as BirdIconSVG } from "../Images/birdIcon.svg";
import { ReactComponent as ChickenIconSVG } from "../Images/chickenIcon.svg";
import { setPetType } from "./petInfo";

type IconProps = SVGProps<SVGSVGElement>;

const PET_TYPE_ICON_COMPONENTS: Record<string, React.ComponentType<IconProps>> = {
    FELINE: PetCatSVG,
    CANINE: PetDogSVG,
    AVIAN: BirdIconSVG,
    CHICKEN: ChickenIconSVG,
};

export {
    PetDogSVG,
    PetCatSVG,
    BirdIconSVG,
    ChickenIconSVG,
};

export const createPetTypeIconLookup = (props?: IconProps): Record<string, React.ReactNode> =>
    Object.fromEntries(
        Object.entries(PET_TYPE_ICON_COMPONENTS).map(([key, Icon]) => [key, <Icon key={key} {...props} />])
    );

export const renderPetTypeIcon = (type: string, props?: IconProps) =>
    createPetTypeIconLookup(props)[setPetType(type)] ?? null;
